export default [
    {
        photo:"covid.png",
        title:"Covid Care",
        text:"Get help with Covid 19. Connect to our experts on Covid 19 symptoms and it’s precautions."
    },
    {
        photo:"eye.svg",
        title:"Eye Care",
        text:"Book an appointment with an Eyecare Specialist who prescribes vision aids and recognise serious optical diseases"
    },
    {
        photo:"heart.png",
        title:"Heart Care",
        text:"We offer convenience to your heartcare with Impulse-12, a Premium Portable 12-channel  ECG Machine"
    }, 
    {
        photo:"dental.png",
        title:"Dental Care",
        text:"Book an appointment with Dentists who prescribes  aids and diaognise serious dental diseases."
    },
     {
        photo:"soul.png",
        title:"Soul Care",
        text:"Book an appointment with our Experts.Discuss all of your mental health issues, including stress, anxiety, and depression, with our specialists.."
    },
     {
        photo:"nutri.png",
        title:"Nutri Care",
        text:"Book an appointment with an Nutrition specialist who will help  you with diet and eating disoders"
    },
    {
        photo:"child.png",
        title:"Child Care",
        text:"Book an appointment with Paediatricians who manages the health of children including behaviourial, physical and mental issues"
    }


]


